import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IAbstractView } from '@core/interfaces';
import { TabsPresenter } from './tabs.presenter';
import { ITabsComponent, ITabItem } from './interfaces';
import { IconComponent } from '../icon/icon.component';
import { DisplayMode, DisplayModeValues } from './enums';

@Component({
	selector: 'app-tabs',
	templateUrl: './tabs.component.html',
	styleUrls: ['./tabs.component.scss'],
	standalone: true,
	imports: [
		CommonModule, 
		FormsModule,
		IconComponent
	],
	providers: [
		TabsPresenter,
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => TabsComponent),
			multi: true
		}
	]
})
export class TabsComponent 
	extends IAbstractView<TabsPresenter> 
	implements ITabsComponent 
{
	@Input() tabs: ITabItem[] = [];
	@Input() selectedTab: string = '';
	@Input() displayMode: DisplayModeValues = DisplayMode.ONLYTEXT;
	@Input() scrollable: boolean = true;
	
	@Output() tabChange = new EventEmitter<string>();

	private _onChange: (value: string) => void = () => {};
	private _onTouched: () => void = () => {};

	constructor(presenter: TabsPresenter) {
		super(presenter);
	}

	onTabChanged(value: string): void {
		this.presenter.onTabChanged(value);
	}

	writeValue(value: string): void {
		if (value !== undefined) {
			this.selectedTab = value;
		}
	}

	registerOnChange(fn: (value: string) => void): void {
		this._onChange = fn;
	}

	registerOnTouched(fn: () => void): void {
		this._onTouched = fn;
	}

	emitChange(value: string): void {
		this.selectedTab = value;
		this.tabChange.emit(value);
		this._onChange(value);
		this._onTouched();
	}
}